import React from 'react'
import BadgeSecondary from './BadgeSecondary.jsx'

export default function BadgeProfile(props){
	const {profile, retrocession, bgColor, tooltip, tooltipText} = props

	return (
		<BadgeSecondary
      icon={<i className="fa-regular fa-hand-holding-box"></i>}
      text={(profile.trad()).charAt(0).toUpperCase() + (profile.trad()).slice(1)}
      textSecondary={retrocession}
      bgColor={bgColor}
      tooltip={tooltip}
      tooltipText={tooltipText}
    />
	);
}